import { Container, Loader as MantineLoader } from "@mantine/core";

type Props = {
  size?: "xs" | "sm" | "md" | "lg" | "xl";
};

export const SimpleLoader = MantineLoader;

export const Loader = ({ size = "lg" }: Props) => {
  return (
    <Container size="xl" style={styles}>
      <MantineLoader size={size} />
    </Container>
  );
};

const styles = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
